export type MultiplayerArchitecture = "convex" | "lan-p2p";

// Hardcoded room transport toggle.
// Switch to "convex" to use the existing backend-driven room architecture.
// NOTE: lan-p2p is not working yet.
export const MULTIPLAYER_ARCHITECTURE: MultiplayerArchitecture = "convex";

export const LAN_P2P_SIGNAL_POLL_MS = 1000;
export const LAN_P2P_PLAYBACK_COUNTDOWN_MS = 3000;

export const CLASSROOM_LOBBY_ROUTE = "classroom-lobby";
const CLASSROOM_GAME_ROUTE = "classroom-game";

// Routes that hold a live room membership. Moving between them keeps the seat;
// leaving the set is what ends it (host closes the room, student leaves it).
export const CLASSROOM_ROUTE_NAMES: ReadonlySet<string> = new Set([
  CLASSROOM_LOBBY_ROUTE,
  CLASSROOM_GAME_ROUTE,
]);
